import { render, staticRenderFns } from "./pcWishlist.vue?vue&type=template&id=02517831&scoped=true"
import script from "./pcWishlist.vue?vue&type=script&lang=js"
export * from "./pcWishlist.vue?vue&type=script&lang=js"
import style0 from "./pcWishlist.vue?vue&type=style&index=0&id=02517831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02517831",
  null
  
)

export default component.exports